import "./button.css";
import styled from "styled-components";

const StyledButton = styled.button.withConfig({
  shouldForwardProp: (prop) =>
    !["smWidth", "mdWidth", "lgWidth"].includes(prop),
})`
  width: ${(props) => props.smWidth || ""};

  @media (min-width: 768px) {
    width: ${(props) => props.mdWidth || ""};
  }

  @media (min-width: 1024px) {
    width: ${(props) => props.lgWidth || ""};
  }
`;

const Button = ({
  onClick,
  text,
  color,
  link,
  className = "",
  smWidth = "",
  mdWidth = "",
  lgWidth = "",
}) => {
  const handleClick = (e) => {
    if (link) {
      window.open(link, "_blank");
    } else if (onClick) {
      onClick(e);
    }
  };

  return (
    <StyledButton
      className={`${className}`}
      smWidth={smWidth}
      mdWidth={mdWidth}
      lgWidth={lgWidth}
      style={{ backgroundColor: color }}
      onClick={handleClick}
    >
      {text}
    </StyledButton>
  );
};

export default Button;
